<template>
  <v-dialog v-model="isDialogOpen" scrollable persistent>
    <v-card>
      <v-card-title>
        <span class="headline">
          <slot name="title"></slot>
        </span>
      </v-card-title>
      <v-card-text>
        <slot name="body"></slot>
      </v-card-text>
      <v-card-actions>
        <slot name="footer"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>
